<template>
	<div v-if="dataLoaded" style="margin-bottom: 10px; " class="read-only-project-basic-section">
		<egranty-section-divider
			:text="'Nazwa konkursu: ' + contestName"
			icon="assessment"
		></egranty-section-divider>
		<br>
		<ProjectReadOnlyHeader :project-data="projectData" :requested-dotation="requestedDotation"/>
		<v-layout v-if="prioritiesSummary.tasks !== undefined">
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title style="background-color: #0075e2; color: #fff">
						<h3>Zadania, kraje i priorytety</h3>
					</v-card-title>
					<v-card-text>
						<div>
							<h4>Zadania</h4>
							<h4 v-for="task in prioritiesSummary.tasks" :key="task">
								&emsp; {{task}}
							</h4>
							<div v-if="prioritiesSummary.extraCountries.length">
								<v-divider style="margin-top: 20px; margin-bottom: 20px"/>
								<h4> Kraje dodatkowe</h4>
								<h4 v-for="(country) in prioritiesSummary.extraCountries" :key="country">
									&emsp; - {{country}}
								</h4>
							</div>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title>
						<h3>Czas trwania projektu</h3>
					</v-card-title>
					<v-card-text>
						<div>
							<v-layout row>
								<v-flex sx6>
									<display-text-component
										:flex="'full-width'"
										label="Data rozpoczęcia"
										:value="projectData.dates.start"/>
								</v-flex>
								<v-flex sx6>
									<display-text-component
										:flex="'full-width'"
										label="Data zakończenia"
										:value="projectData.dates.end"/>
								</v-flex>
							</v-layout>
						</div>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12>
				<ContestOfferSummaryBidderDetailsView title="Oferent"
					:bidderId="bidderId" :projectId="$route.params.projectId"/>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex xs12>
				<div v-for="(id, index) in otherBiddersId" :key="id">
					<ContestOfferSummaryBidderDetailsView :title="'Współoferent nr: ' + (index+1).toString()"
						:bidderId="id" :projectId="$route.params.projectId"/>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import {Numbers} from "@/utils/Numbers";
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";
	import ContestOfferSummaryBidderDetailsView from "../../offer/components/ContestOfferSummaryBidderDetailsView";
	import {Project} from "@/api/generated/Project";
	import {PublicContest} from "@/api/generated/PublicContest";
	import ProjectReadOnlyHeader from "../ProjectReadOnlyHeader";

	export default {
		name: "ProjectGeneralData",
		components: {
			ProjectReadOnlyHeader,
			ContestOfferSummaryBidderDetailsView,
			DisplayTextComponent,
			EgrantySectionDivider
		},

		props: {
			contestConfiguration: Object,
			projectData: Object,
		},

		mixins: [
			Numbers
		],

		data () {
			return {
				contestName: 'brak nazwy',
				requestedDotation: null,
				prioritiesSummary: {},
				projectSummaryData: {},
				bidderId: 0,
				subBidders: [],
				otherBiddersId: [],
				projectDataLoaded: false,
				contestConfigurationLoaded: false
			};
		},

		computed: {
			dataLoaded: function () {
				return this.projectDataLoaded && this.contestConfigurationLoaded;
			}
		},

		watch: {
			projectData: {
				immediate: true,
				handler (val) {
					this.bidderId = val.mainBidderId;
					this.otherBiddersId = val.otherBiddersId;
					this.projectDataLoaded = true;
					let version = "";
					if (this.$route.params.version) {
						version = this.$route.params.version;
					}
					Project.getProjectPrioritiesSummary(this, this.$route.params.projectId, version, response => this.prioritiesSummary = response);
				}
			},
			contestConfiguration: {
				immediate: true,
				handler () {
					this.contestConfigurationLoaded = true;
				}
			}
		},

		created () {
			PublicContest.getContestName(this, this.projectData.contestId, successResponse => {
					this.contestName = successResponse.name;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować nazwy konkursu", errorResponse);
				});
			Project.getRequestedDotation(this, this.$route.params.projectId, successResponse => {
					this.requestedDotation = successResponse.requestedDotation;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się załadować wnioskowanej kwoty dotacji", errorResponse);
				});
		}
	};
</script>

<style scoped>
</style>
